import requestv2 from "~/utils/http-v2";

const salarySlipApi = {
	gets : async (params) => {
		const url = 'v2/salary-slip';
		return await requestv2.get(url, {params});
	},
	add : async (params) => {
		const url = 'v2/salary-slip';
		return await requestv2.post(url, params);
	},
	update : async (params) => {
		const url = `v2/salary-slip/${params.id}`;
		return await requestv2.patch(url, params);
	},
	delete : async (id) => {
		const url = `v2/salary-slip/${id}`;
		return await requestv2.delete(url);
	},
};

export default salarySlipApi;
